import { ReactNode } from "react";
import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";

export interface CardInfoProps {
    title: ReactNode;
    value: ReactNode;
    demo?: boolean;
}

function CardInfo(props: CardInfoProps) {
    const stackProps: StackProps = {
        sx: {
            gap: 1,
        },
    };

    const titleProps: TypographyProps = {
        sx: {
            fontSize: {
                xs: 11,
                lg: 11,
            },
            lineHeight: 1.2,
        },
        children: props.title,
    };

    const valueProps: TypographyProps = {
        sx: {
            fontSize: {
                xs: 20,
                lg: 28,
            },
            fontWeight: 700,
            lineHeight: 1,
            ...(props.demo && {
                // filter: blur(6px);
                filter: "blur(6px)",
            }),
        },
        children: props.value,
    };

    return (
        <Stack {...stackProps}>
            <Typography {...titleProps} />
            <Typography {...valueProps} />
        </Stack>
    );
}

export default CardInfo;
